// Globals
import { useTranslation } from 'react-i18next';

// Modules
import { StyledSettingsCard } from '@/modules/SettingsCommon';

// Components
import { EditIcon } from '@/icons';
import { Button, EmptyDataThumbnail, Link } from '@/ui';
import { StyledCardTitle, StyledDescription, StyledName, StyledTitleWrapper } from './RequiredDocumentsCardStyles';

// Models
import { IDocument } from '@/models/documentsSettings.model';
import { ROUTES } from '@/models/router.model';

type TRequiredDocumentsCardProps = {
  documents: IDocument[];
  source: string;
  propertyType: string;
};

const RequiredDocumentsCard = ({ documents, source, propertyType }: TRequiredDocumentsCardProps) => {
  const { t } = useTranslation('documents');
  return (
    <StyledSettingsCard>
      <StyledTitleWrapper>
        <StyledCardTitle>
          {t('card_title_documents', {
            context: source.toLowerCase(),
            count: documents.length,
          })}
        </StyledCardTitle>
        <Link path={ROUTES.REQUIRED_DOCUMENTS.replace(':propertyType', propertyType).replace(':source', source)}>
          <Button type="primary" shape="round" icon={<EditIcon />} iconPosition="end">
            {t('button_edit_list')}
          </Button>
        </Link>
      </StyledTitleWrapper>
      {!documents.length && <EmptyDataThumbnail />}
      {documents?.map((item) => (
        <div key={item?.id}>
          <StyledName>{item?.name_en}</StyledName>
          <StyledDescription>{item?.description_en}</StyledDescription>
        </div>
      ))}
    </StyledSettingsCard>
  );
};

export default RequiredDocumentsCard;
